import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { ProjectTeamComponent } from './project-team.component';
import { DxDataGridModule, DxAutocompleteModule, DxCheckBoxModule} from 'devextreme-angular';
import { I18nModule } from "app/shared/i18n/i18n.module";
import { MaterialModule } from 'app/material.module';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ProjectTeamRoutingModule } from './project-team-routing.module';
import { OrgChartModule } from 'app/components/org-chart/org-chart.module';

@NgModule({
  imports: [
    CommonModule,
    DxDataGridModule,
    I18nModule,
    MaterialModule,
    FormsModule,
    NgxSpinnerModule,
    ProjectTeamRoutingModule,
    DxAutocompleteModule,
    DxCheckBoxModule,
    OrgChartModule
  ],
  declarations: [
    ProjectTeamComponent
  ]
})
export class ProjectTeamModule { }
